<template>
  <v-expansion-panels
    v-model="expansionPanelsModel"
    focusable
    class="mt-3"
  >
    <historico-expansion-panel
      titulo="Status"
      :items="historicoStatus"
      :get-items="getHistoricoStatus"
    >
      <timeline-status :items="historicoStatus" />
    </historico-expansion-panel>

    <historico-expansion-panel
      titulo="Responsáveis pelo atendimento"
      :items="historicoAtendentes"
      :get-items="getHistoricoAtendentes"
    />

    <historico-expansion-panel
      titulo="Alterações"
      :items="alteracoesHistorico"
      :get-items="getAlteracoesHistorico"
    >
      <alteracoes-container
        :ticket-id="ticketSelecionadoId"
        :items="alteracoesHistorico"
        :is-get-alteracoes-historico-loading="isGetAlteracoesHistoricoLoading"
      />
    </historico-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import Vue from 'vue'
import HistoricoExpansionPanel from './HistoricoExpansionPanel.vue'
import AlteracoesContainer from './alteracoes/AlteracoesContainer.vue'
import TimelineStatus from './timeline/TimelineStatus.vue'
import useAtendimentoStore from '@/store/atendimento'
import TicketService from '@/services/modules/TicketService'

export default {
  components: {
    HistoricoExpansionPanel,
    TimelineStatus,
    AlteracoesContainer,
  },

  setup() {
    const { ticketSelecionadoId } = storeToRefs(useAtendimentoStore())

    const expansionPanelsModel = ref(null)

    const historicoStatus = ref([])
    const historicoAtendentes = ref([])
    const alteracoesHistorico = ref([])

    async function getHistoricoStatus() {
      historicoStatus.value = await TicketService.getTicketHistoricoStatus(ticketSelecionadoId.value)
    }
    async function getHistoricoAtendentes() {
      historicoAtendentes.value = await TicketService.getTicketHistoricoAtendentes(ticketSelecionadoId.value)
    }

    const isGetAlteracoesHistoricoLoading = ref(false)
    async function getAlteracoesHistorico() {
      try {
        isGetAlteracoesHistoricoLoading.value = true
        alteracoesHistorico.value = await TicketService.getTicketHistoricoAlteracoes(ticketSelecionadoId.value)
        isGetAlteracoesHistoricoLoading.value = false
      } catch {
        isGetAlteracoesHistoricoLoading.value = false
        Vue.$toast.error('Não foi possível carregar o histórico de alterações. Tente novamente.')
      }
    }

    function closeExpansionPanels() {
      expansionPanelsModel.value = null
    }
    async function resetData() {
      if (!ticketSelecionadoId.value) return
      historicoStatus.value = []
      historicoAtendentes.value = []
      alteracoesHistorico.value = []
      closeExpansionPanels()
    }
    watch(() => ticketSelecionadoId.value, resetData, { immediate: true })

    return {
      ticketSelecionadoId,
      expansionPanelsModel,
      historicoStatus,
      getHistoricoStatus,
      historicoAtendentes,
      getHistoricoAtendentes,
      isGetAlteracoesHistoricoLoading,
      alteracoesHistorico,
      getAlteracoesHistorico,
    }
  },
}
</script>
